import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      country: '55'
    }
  },
  computed: {
    ...mapGetters(['loggedUserExpirated']),
    brazilPhoneNumberRegex() {
      return new RegExp('^[1-9]{2}[9]{0,1}[0-9]{1}[0-9]{3}[0-9]{4}$')
    },
    regexUrl() {
      return new RegExp(
        '^(([^\0]+)?http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?'
      )
    }
  },
  methods: {
    isValidNumber(p) {
      var phoneRe = /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm
      var digits = p.replace(/\D/g, '')
      return phoneRe.test(digits)
    },
    replaceAll(target, search, replacement) {
      return target.split(search).join(replacement)
    },
    UUID() {
      var dt = new Date().getTime()
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function(c) {
          var r = (dt + Math.random() * 16) % 16 | 0
          dt = Math.floor(dt / 16)
          return (c == 'x' ? r : r & (0x3 | 0x8)).toString(16)
        }
      )
      return uuid
    },
    remove(item, list) {
      const index = list.indexOf(item)
      if (index >= 0) list.splice(index, 1)
    },
    formatDate(date) {
      if (date) {
        var formated_date = new Date(date),
          day = formated_date.getDate().toString(),
          dayF = day.length == 1 ? '0' + day : day,
          mounth = (formated_date.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
          mounthF = mounth.length == 1 ? '0' + mounth : mounth,
          yearF = formated_date.getFullYear()
        return dayF + '/' + mounthF + '/' + yearF
      }
      return ''
    },
    formatDateHour(date) {
      if (date) {
        var formated_date = new Date(date),
          day = formated_date.getDate().toString(),
          dayF = day.length == 1 ? '0' + day : day,
          mounth = (formated_date.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
          mounthF = mounth.length == 1 ? '0' + mounth : mounth,
          yearF = formated_date.getFullYear()

        var hour = formated_date.getHours().toString()
        var min = formated_date.getMinutes().toString()
        if (min.length == 1) min = '0' + min
        if (hour.length == 1) hour = '0' + hour

        return dayF + '/' + mounthF + '/' + yearF + ' às ' + hour + ':' + min
      }
      return ''
    },
    formatHour(date) {
      if (date) {
        var formated_date = new Date(date)
        var hour = formated_date.getHours().toString()
        var min = formated_date.getMinutes().toString()
        if (min.length == 1) min = '0' + min
        if (hour.length == 1) hour = '0' + hour
        return hour + ':' + min
      }
      return ''
    },
    formatDatePicker(date) {
      if (isNaN(Date.parse(date))) {
        return date
      } else {
        var date_formated = new Date(date).toISOString().substr(0, 10)
        const [year, month, day] = date_formated.split('-')
        return `${day}-${month}-${year}`
      }
    },
    getDateTimeStamp(date) {
      if (isNaN(Date.parse(date))) return date
      else return new Date(date).getTime()
    },
    addDaysToDate(date, days) {
      return new Date(date.setDate(date.getDate() + days))
    },
    addHoursToDate(date, hours) {
      return new Date(date.setHours(date.getHours() + hours))
    },
    addMinutesToDate(date, minutes) {
      return new Date(date.setMinutes(date.getMinutes() + minutes))
    },
    addSecondsToDate(date, seconds) {
      return new Date(date.setSeconds(date.getSeconds() + seconds))
    },
    getFowardDate(days, hours, minutes, seconds, date = null) {
      if (!date) {
        date = new Date()
      }
      date = this.addDaysToDate(date, days)
      date = this.addHoursToDate(date, hours)
      date = this.addMinutesToDate(date, minutes)
      date = this.addSecondsToDate(date, seconds)
      return date
    },
    countDownTime() {
      var countDownDate = new Date(this.loggedUser.expiration_date).getTime()
      var self = this
      var x = setInterval(function() {
        var now = new Date().getTime()
        var distance = countDownDate - now
        var days = Math.floor(distance / (1000 * 60 * 60 * 24))
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        )
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        var seconds = Math.floor((distance % (1000 * 60)) / 1000)
        hours = hours < 10 ? '0' + hours : hours
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds
        self.countDown = days + ' dias ' + hours + ':' + minutes + ':' + seconds
        if (distance < 0) {
          self.countDown = 'EXPIROU'
          clearInterval(x)
        }
      }, 1000)
    },
    registerCountry(country) {
      this.country = country.dialCode
    },
    onUpdatePhoneNumber(payload) {
      let number = payload?.number?.e164 ? payload.number.e164 : ''
      let isValid = false
      number = number
        .replace('+', '')
        .replace(' ', '')
        .replace(' ', '')
        .replace(')', '')
        .replace('-', '')
      // if (this.regionCode == 'BR' && number)
      //   isValid = this.brazilPhoneNumberRegex.test(number)
      // else isValid = Boolean(payload.isValid)
      return { phone: number, isValid: payload.isValid }
    },
    open_external(link) {
      window.open(link, '_blank')
      this.$emit('close')
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'export.csv') //or any other extension
      document.body.appendChild(link)
      link.click()
    }
  }
}
